import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {SyncActionModel} from "../../../commons/models/sync-action.model";

export class TasksOfflineActionsTableComponent implements IController {
  actions: SyncActionModel[];
  tasks: any[];

  public tasksMap;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.tasks && !changes.tasks.isFirstChange()) {
      this.tasksMap = _.keyBy(this.tasks, 'id');
    }
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('tasksOfflineActionsTable', {
    bindings: {
      actions: '<',
      tasks: '<?'
    },
    template: require('./tasks-offline-actions-table.html').default,
    controller: TasksOfflineActionsTableComponent
  });
